import { render, staticRenderFns } from "./otherinCome.vue?vue&type=template&id=733cb1e0&scoped=true"
import script from "./otherinCome.vue?vue&type=script&lang=js"
export * from "./otherinCome.vue?vue&type=script&lang=js"
import style0 from "./otherinCome.vue?vue&type=style&index=0&id=733cb1e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733cb1e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('733cb1e0')) {
      api.createRecord('733cb1e0', component.options)
    } else {
      api.reload('733cb1e0', component.options)
    }
    module.hot.accept("./otherinCome.vue?vue&type=template&id=733cb1e0&scoped=true", function () {
      api.rerender('733cb1e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/institutionalWalletChild/child/otherinCome.vue"
export default component.exports